<template>
  <div class="Dljzbox">
    <DLJZ />
  </div>
</template>
<script>
import DLJZ from "@/components/DLJZ.vue";
export default {
  components: { DLJZ },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Dljzbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>